// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initPartnerTool = function () {
    (function (_super) {
        coffeeExtends(PartnerTool, _super);
        function PartnerTool() {
            return PartnerTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(PartnerTool, 'partner');
        PartnerTool.label = 'Insert Partner';
        PartnerTool.icon = 'partner';
        PartnerTool.tagName = 'prt';
        PartnerTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const partnerHtml = `<${PartnerTool.tagName} contenteditable="false">PARTNER NAME</${PartnerTool.tagName}>`;
            // http://getcontenttools.com/api/html-string
            element.content = tip.concat(
                new window.HTMLString.String(' ', true),
                partnerHtml,
                new window.HTMLString.String(' ', true),
                tail,
                false
            );
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 12, cursor + 12);
            element.selection(selection);
            ContentTools.Tools.LineBreak.dispatchEditorEvent('tool-applied', {
                name: 'CKP_PartnerTool',
                transform: true
            });
            callback(true);
        };
        return PartnerTool;
    })(ContentTools.Tools.LineBreak);
};
